import { css } from 'styled-components';
import token from 'styled-token';
import { StyledRatingStars } from '../../components/RatingStars/RatingStars.styles';
import { StyledTextButton } from '../../components/TextButton/TextButton.styles';
import { spaceMixin } from '../spaceMixin';
import { TextButtonMixin } from './TextButtonMixin';

/** @class LabeledRatingStars */
/** @method */
export var LabeledRatingStarsMixin = function LabeledRatingStarsMixin(props) {
  return token({
    buttonType: 'LabeledRatingStars.buttonType',
    fontType: 'LabeledRatingStars.fontType',
    marginRight: 'LabeledRatingStars.marginRight'
  }, function (_ref) {
    var _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'secondary' : _ref$buttonType,
      _ref$fontType = _ref.fontType,
      fontType = _ref$fontType === void 0 ? 'bodySmall' : _ref$fontType,
      marginRight = _ref.marginRight;
    return css(["display:inline-flex;align-items:center;", "{margin-right:", ";}", "{", "}"], StyledRatingStars, marginRight ? marginRight + "px" : spaceMixin('xs')(props), StyledTextButton, TextButtonMixin(Object.assign({}, props, {
      buttonType: buttonType,
      fontType: fontType
    })));
  })(props);
};